import React from "react";
import { ContentSection } from "../Layout/ContentSection";
import { HeadingSection } from "../Layout/HeadingSection";
import { Levels } from "../models/users";
import { RLink } from "../DesignSystem/RLink";
import { Paragraph } from "../DesignSystem/formatting/Paragraph";

export const ExplainXPPage = (): JSX.Element => {
  return (
    <div>
      <HeadingSection title="What is XP?">Considered title: XP eXPlanation</HeadingSection>

      <ContentSection>
        <Paragraph>
          XP is a <s>complete measure of your value as a human being</s> a goofy way to encourage songwriting! As you
          do music related things, like submit songs or vote on entries, you will gain XP. Eventually, you will level
          up.
        </Paragraph>

        <Paragraph>
          Higher level users are assumed to be more experienced, and therefore vote slightly stronger in contests.
          Continue to level up and you may gain other benefits and secrets.
        </Paragraph>

        <Paragraph>You can get XP in all sorts of ways. Here are some:</Paragraph>

        <ul>
          <li>
            <strong>+20 XP</strong>: Submit a track.{" "}
          </li>
          <li>
            <strong>+0 to 3000 XP</strong>: Get a good score in a contest. (Higher scores will get more XP.)
          </li>
        </ul>

        <Paragraph>Cool stuff you can do with XP:</Paragraph>

        <ul>
          <li>
            <strong>Always</strong>: Your XP affects your voting strength. More XP means you are a more influential
            voter.
          </li>
          <li>
            <strong>1000 XP</strong>: You can vote in any compo, not just compos that you participated in.{" "}
          </li>
          <li>
            <strong>5000 XP</strong>: You become part of the Salsa Compo Planning Committee, and are allowed to suggest
            and vote on salsa compos with the other members of this exclusive group!{" "}
          </li>
        </ul>

        <Paragraph>XP requirements:</Paragraph>

        <ul>
          {Levels.map((val, index) => (
            <li key={index}>
              <strong>LV {index}</strong>: {val}
            </li>
          ))}
        </ul>

        <h2>
          <RLink to="/edit/profile">Go Back.</RLink>
        </h2>
      </ContentSection>
    </div>
  );
};